import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import * as config from '../shared/config/app.config';
import { BaseService } from '../shared/services/base.service';

@Injectable({
  providedIn: 'root'
})
export class AsmResetPasswordService {
  public salesAgentUsers = new BehaviorSubject<any>(null);
  salesAgentUsers$ = this.salesAgentUsers.asObservable();

  public sendUserMail = new BehaviorSubject<any>(null);
  sendUserMail$ = this.sendUserMail.asObservable();

  constructor(
    public baseService: BaseService,
  ) { }

  public getUserAgent(params): Observable<any> {
    let b2buid = JSON.parse(localStorage.getItem('accountId'));
    return this.baseService
      .get(`${config.GET_USER_AGENT}${b2buid}`, params)

  }

  public sendResetMail(params) {
    this.baseService
      .post(`${config.SEND_USER_MAIL}`, params)
      .subscribe((res) => {
        this.sendUserMail.next(res);
      });
  }
}
